import { GroupsServiceInterface } from 'domain/services';
import { GetAllGroupsUserUseCaseInterface } from 'domain/usecases';

interface UseCasesInjection {
  getAllGroupsUser: GetAllGroupsUserUseCaseInterface;
}

export class GroupsService implements GroupsServiceInterface {
  private readonly _getAllGroupsUser: GetAllGroupsUserUseCaseInterface;

  constructor(usecases: UseCasesInjection) {
    this._getAllGroupsUser = usecases.getAllGroupsUser;
  }

  getAllGroupsUser(
    params?: GetAllGroupsUserUseCaseInterface.Params,
  ): Promise<GetAllGroupsUserUseCaseInterface.Result> {
    return this._getAllGroupsUser.execute(params);
  }
}
